import ReferenceRoom from '../../features/referenceRoom/components/ReferenceRoom';
import values from '../../features/referenceRoom/config/values';
import Head from 'next/head';

const isValidSubject = (subject) => {
  return values.menu.some((menu) => menu.subject === subject);
};

export async function getServerSideProps(context) {
  const { subject, category, pageno } = context.query;

  if (!isValidSubject(subject)) {
    return {
      redirect: {
        permanent: false,
        destination: '?subject=total',
      },
      props: {
        subject: 'total',
        pageno: 1,
        category: '전체',
      },
    };
  }

  return {
    props: {
      subject,
      category: category ?? '전체',
      pageno: pageno ?? 1,
    },
  };
}

const ReferenceRoomPage = ({ subject, history, category, pageno }) => {
  return (
    <>
      <Head>
        <meta
          property="og:description"
          itemProp="description"
          content={'무료로 활용가능한 프린트가 담긴 학습자료실'}
        />
        <meta
          name="description"
          content="무료로 활용가능한 프린트가 담긴 학습자료실"
        />
      </Head>
      <ReferenceRoom
        history={history}
        subject={subject}
        category={category}
        pageno={pageno}
      />
    </>
  );
};

export default ReferenceRoomPage;
